import { useTranslation } from "react-i18next";
import { localDateTime } from "../../../lib/datetime";
import { LogOut } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

// Audit trail of force-logout actions.
export const RevocationsCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;

  return (
    <NeuCard
      data-testid="system-revocations-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="label-xs flex items-center gap-2">
          <LogOut className="h-4 w-4 text-primary" /> {t("system.revocations")}
        </p>
        <span className="rounded-full bg-background px-3 py-1 font-mono text-xs font-bold shadow-neu-sm" dir="ltr">
          {data.total}
        </span>
      </div>

      {!data.items.length ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="system-revocations-empty">
          {t("system.noRevocations")}
        </p>
      ) : (
        <ul className="mt-4 grid gap-1.5" data-testid="system-revocation-list">
          {data.items.slice(0, 6).map((item, i) => (
            <li
              key={`${item.user_id}-${i}`}
              className="flex items-center justify-between gap-3 rounded-xl bg-background px-3 py-2 text-[11px] shadow-neu-sm"
            >
              <span className="truncate font-bold">{item.user}</span>
              <span className="shrink-0 font-mono text-muted-foreground" dir="ltr">
                {item.by} · {localDateTime(item.at)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};
